export default __webpack_public_path__ + "static/media/j9.cd8bed41.png";